export default __webpack_public_path__ + "static/media/x-icon-grn.abca66cb.svg";